import './style.css';

export default function Footer(){
	return (
		<div className={"footer"}>
			© {new Date().getFullYear()} sunpiology.com
		</div>
	);
}